
export const auth = {
  signIn: 'Entrar',
  signUp: 'Criar Conta',
  email: 'Email',
  password: 'Senha',
  confirmPassword: 'Confirmar Senha',
  forgotPassword: 'Esqueceu a senha?',
  noAccount: 'Não tem uma conta?',
  hasAccount: 'Já tem uma conta?',
  signInWithGoogle: 'Entrar com Google',
  signUpWithGoogle: 'Cadastrar com Google',
  resetPassword: 'Redefinir Senha',
  backToSignIn: 'Voltar ao Login',
  resetEmailSent: 'Email de redefinição enviado',
  invalidCredentials: 'Email ou senha inválidos',
  emailAlreadyExists: 'Já existe uma conta com este email',
  passwordTooWeak: 'A senha deve ter pelo menos 6 caracteres',
  genericError: 'Ocorreu um erro. Tente novamente.',
  signInSuccess: 'Sessão iniciada com sucesso!',
  signUpSuccess: 'Conta criada com sucesso!',
  signOutSuccess: 'Sessão encerrada com sucesso!',
  fullName: 'Nome Completo',
  companyName: 'Nome da Empresa',
  companySize: 'Quantas pessoas trabalham na empresa?',
  organization: 'Organização (Opcional)',
  department: 'Departamento (Opcional)',
  position: 'Cargo (Opcional)',
  phone: 'Telefone (Opcional)',
  createAccount: 'Criar Conta',
  alreadyRegistered: 'Já está registrado?',
  newPassword: 'Nova Senha',
  updatePassword: 'Atualizar Senha',
  passwordUpdated: 'Senha atualizada com sucesso!',
  resetEmailInstructions: 'Digite seu endereço de email e enviaremos um link para redefinir sua senha.',
  sendResetEmail: 'Enviar Email de Redefinição',
  enterNewPassword: 'Digite sua nova senha abaixo.',
  checkEmail: 'Verifique seu email para o link de redefinição de senha.'
};
